<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15t7Fm3/media/FC-9798889107514.jpg?1708005252041" alt="This image is the cover for the book Synchronicity"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Synchronicity
      </h1>
      <p class="bookDescription body article font2">
        <p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;'><em><span style='font-size:16px;font-family:"Times New Roman",serif;'>Fractured Identities</span></em><span style='font-size:16px;font-family:"Times New Roman",serif;'> offers an unflinching look into the complexities of desire, identity, and survival within a Hungarian Jewish family during the crucible of the Second World War. Brace yourself for a harrowing psychosexual journey that confronts the limits of the human psyche and morality.</span></p><p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;'><span style='font-size:16px;font-family:"Times New Roman",serif;'>At the story’s center is an uncle – a Jungian psychiatrist – whose career is stifled under the oppressive Nazi regime. Bereft of his practice, he grapples with the dissolution of his professional identity. Opposite him is his wife, a once-successful actress and singer. Constrained by her Jewish heritage, she challenges both her own and her husband’s sexual boundaries as a form of escape from the confinements of religious and societal norms.</span></p><p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;'><span style='font-size:16px;font-family:"Times New Roman",serif;'>Their niece, prodigiously gifted and strikingly beautiful, is raised by her aristocratic, war-hero grandfather. Throughout the war, she faces a relentless assault on her body and mind. Her identity oscillates violently, from a vulnerable Jewish girl to a fierce supporter of Nazi ideology, even as her capacity for scientific innovation and acts of heroism grow. Yet she, too, cannot evade the war’s corrosive ethical compromises.</span></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Daryl Chaste
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?39c0530b